import { PlayerSide } from "../ai/TableAI";
import { ContractResult } from "../screen/dealcomplete/DealCompleteDealsContent";

export function GetContractResult(dealWinningSide: PlayerSide, attackingSide: PlayerSide): ContractResult
{
    let contractResult: ContractResult;
    if (dealWinningSide == PlayerSide.NONE) {
        contractResult = ContractResult.CONTRACT_TIE;
    }
    else {
        if (dealWinningSide == attackingSide) {
            contractResult = ContractResult.CONTRACT_SUCCESS;
        }
        else {
            contractResult = ContractResult.CONTRACT_FAILURE;
        }
    }
    return contractResult;
}